import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const REFERRAL_STORAGE_KEY = 'referral_code';

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const params = new URLSearchParams(search);
    const ref = params.get('ref');
    if (ref && ref.trim()) {
      try {
        sessionStorage.setItem(REFERRAL_STORAGE_KEY, ref.trim().toUpperCase());
      } catch (_) {}
    }
  }, [search]);

  return null;
};

export default ScrollToTop;